import { useEffect } from 'react';
import { ScoreAppearTransition } from '../summary/transitions';
import calculateScore from './calculate-score';
import { useAllMessages } from 'store/selectors/messages';
import trackEvent from 'utils/analytics';
import { Box } from 'v1/ui';

export default function Score() {
  return (
    <ScoreAppearTransition>
      <div>
        <Content />
      </div>
    </ScoreAppearTransition>
  );
}

function Content() {
  const messages = useAllMessages();
  const { comment, grade, percent } = calculateScore(messages);

  useEffect(() => {
    trackEvent.updateReviewScore(percent);
  }, [percent]);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        gridColumnGap: 3,
        gridRowGap: 2,
        pl: 3,
        pt: 14,
        pb: 5,
        mb: 2,
        bg: 'rgba(139, 23, 255, 1)',
        color: 'white',
      }}
    >
      <Box sx={{ fontSize: 15, fontWeight: 600 }}>Review Score</Box>
      <Box sx={{ fontSize: 15 }}>{`${percent}`}/100</Box>
      <Box sx={{ gridColumn: 'span 2', height: '1px', bg: 'white30' }} />
      <Box
        sx={{ fontSize: 72, lineHeight: 1, fontWeight: 700 }}
      >{`${grade}`}</Box>
      <Box sx={{ fontSize: 12, pt: '6px', pr: '2px' }}>{`${comment}`}</Box>
    </Box>
  );
}
